export const extractFilenameFromDisposition = (disposition: string): string | null => {
  const quotedMatch = disposition.match(/filename="([^"]+)"/i);
  if (quotedMatch?.[1]) return quotedMatch[1];

  const unquotedMatch = disposition.match(/filename=([^;]+)/i);
  return unquotedMatch?.[1]?.trim() ?? null;
};

export const triggerBlobDownload = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
};
